export interface DanceStyle {
	value: number;
	label: string;
}

export interface Teacher {
	value: number;
	label: string;
}

export interface EventType {
	value: number;
	label: string;
}

export interface DanceStyleNode {
	id: number;
	name: string;
}

export interface TeacherNode {
	id: number;
	title: {
		rendered: string;
	};
	acf: {
		firstname: string;
		lastname: string;
	};
}

export type Class = {
	start_date_time: string;
	end_date_time: string;
};

export interface WeeklyClass extends Class {
	last_day: null | string;
}

export type CancelledDate = {
	cancelled_date: string;
};

export interface CourseNode {
	id: number;
	link: string;
	title: {
		rendered: string;
	};
	acf: {
		maintitle: string;
		subtitle: string;
		courses: WeeklyClass[];
		cancelled_on: CancelledDate[] | null;
		venue: string;
		voraussetzungen: string;
		teacher?: number[] | null;
		weekly_or_custom: "custom" | "weekly";
		custom_courses: Class[] | null;
	};
	categories: number[] | null;
	event_type: number[] | null;
	event_label: string;
}

export interface EventNode {
	id: number;
	title: {
		rendered: string;
	};

	link: string;

	acf: {
		maintitle: string;
		subtitle: string;
		start_date_time: string;
		end_date_time: string;
		venue: string;
		voraussetzungen: string;
		teacher?: number[] | null;
		custom_time: boolean;
	};
	categories: number[] | null;
	event_type: number[] | null;
	event_label: string;
}

export interface EventData extends EventNode {
	event: boolean;
	color: string;
	dance_tags: string[] | null;
}

export interface DayEventData extends EventData {
	day_start_date_time?: Date;
	day_end_date_time?: Date;
}

export interface CourseData extends CourseNode {
	event: boolean;
	color: string;
	dance_tags: string[] | null;
}

export interface DayCourseData extends CourseData {
	day_start_date_time?: Date;
	day_end_date_time?: Date;
}

export type CalendarNode = CourseNode | EventNode;
export type CalendarItem = CourseData | EventData;

export interface EventOrCourse {
	id: number;
	date?: string;
	acf: {
		courses?: {
			start_date_time: string;
			end_date_time: string;
			last_day: string | null;
		}[];
		custom_time_description?: string;
		cancelled_on?: any; // Add the correct type if needed
		register_by?: string;
		form_number?: number | null;
		email?: string;
	};
}

export type GroupedEvents = Record<string, EventData[]>;

export enum ViewOptions {
	WEEKLY = "weekly",
	MONTHLY = "monthly",
	LIST = "list",
}

export interface EventTypeNode {
	id: number;
	name: string;
	slug: string;
	acf: {
		farbe: string;
	};
}
export type ColorsData = {
	id: number;
	color: string;
	label: string;
};

export type DanceStyleData = {
	id: number;
	name: string;
};

export enum WEEKLY_OR_CUSTOM {
	WEEKLY = "weekly",
	CUSTOM = "custom",
}
